import React, { useState } from 'react';
import { Grid, Snackbar, Alert } from '@mui/material';
import PolicyForm from '../../../components/Forms/PolicyForm';

const AddOfficePolicyPage = () => {
  const [open, setOpen] = useState(false);
  const [pTitle, setPTitle] = useState('Add New Office Policy');
  const [type, setType] = useState('OFFICE_POLICY');

  const handleSuccess = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <Grid container spacing={3}>
      <Grid item sx={{ width: '100%' }}>
        <PolicyForm onSuccess={handleSuccess} pTitle={pTitle} type={type}/>
      </Grid>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleClose}
          severity="success"
          sx={{ width: '100%' }}
          variant="filled"
        >
          Policy saved successfully!
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default AddOfficePolicyPage;
// import React from 'react';
// import { Grid } from '@mui/material';
// import PolicyForm from '../../components/PolicyForm';

// const AddOfficePolicyPage = () => {
//   return (
//     <Grid container spacing={3}>
//       <Grid item sx={{ width: '100%' }}>
//         <PolicyForm onSuccess={() => alert('Policy saved successfully!')} />
//       </Grid>
//     </Grid>
//   );
// };

// export default AddOfficePolicyPage;
